<template>
	<el-container class="service-information">
		<el-header class="header">
			<span>我的资料</span>
			<i class="el-icon-close" @click="close"></i>
		</el-header>
		<el-main class="main">
			<div class="left">
				<img :src="userinfo.header_img">
				<el-upload :action='"api/upload/upload"' :data="data" :on-success="uploadImg" :auto-upload="true">
					<i class="el-icon-edit-outline"></i>
					<span>修改</span>
				</el-upload>
			</div>
			<div class="right">
				<p>
					<span class="right-title">账号:</span>
					<span>{{userinfo.userCode}}</span>
				</p>
				<p>
					<span class="right-title">个性签名:</span>
					<span>{{userinfo.qm}}</span>
				</p>
				<p>
					<span class="right-title">用户类型</span>
					<span>卖家客服</span>
				</p>
				<p>
					<span class="right-title">店铺名称</span>
					<span>{{userinfo.store_name}}</span>
				</p>
			</div>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		name: 'ServiceInformation',
		data() {
			return {
				data: {
					type: 'image'
				}, //文件上传附带参数
				URL:'http://kefu.tjztct.com'
			}
		},
		props: {
			userinfo: Object
		},
		methods: {
			close() {
				this.$emit('closePop')
			},
			//文件上传成功
			uploadImg(response, file, fileList) {
				console.log(response);
				this.modifyHeadImg(response.data);
			},
			//修改头像的方法
			async modifyHeadImg(param) {
				console.log(param)
				var res = await this.$axios.post('/friends/editUserInfo', {
					User_code: this.userinfo.userCode,
					param: param,
					type: 'header_img'
				})
				if (res.data.done) {
					this.userinfo.header_img = this.getAvitor(param)
				} else {
					this.$message.error(res.data.msg)
				}
			},
			getAvitor(portrait) {
				var now_avitor;
				if (portrait == null || portrait == "null" || portrait == "") {
					// now_avitor = '../image/default_portrait.png'
				} else if (portrait != null || portrait != "null") {
					if (portrait.substr(0, 8).toLowerCase() == "https://" || portrait.substr(0, 7).toLowerCase() == "http://") {
						now_avitor = portrait;
					} else {
						now_avitor = this.URL + portrait;
					}
				}
				return now_avitor;
			},
		},
		created() {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.service-information {
		width: 600px;
		height: 400px;
		overflow: hidden;
	}

	.header,
	.main {
		margin: 0;
		padding: 0 24px;
	}

	.header {
		background-color: #354052;
		color: #fff;
		display: flex;
		box-sizing: border-box;
		justify-content: space-between;
		align-items: center;
		height: 40px;
		font-size: 14px;
	}

	.header i {
		font-size: 22px;
	}

	.main .left {
		width: 90px;
		display: inline-block;
	}

	.main .right {
		width: calc(100% - 90px);
		display: inline-block;
		padding-top: 48px;
		padding-left: 46px;
		font-size: 14px;
		box-sizing: border-box;
		color: #888888;
	}

	.right .right-title {
		width: 90px;
		display: inline-block;
		color: #333;
	}

	.main .left img {
		width: 90px;
		height: 90px;
		border-radius: 50%;
		margin-top: 20px;
		margin-bottom: 12px;
	}

	.main .left div {
		display: flex;
		width: 100%;
		font-size: 16px;
		height: 24px;
		color: #5792fa;
		align-content: center;
		justify-content: center;
	}

	.main .left div i {
		font-size: 20px;
	}
</style>
